export const ONE_HOUR_IN_SECONDS = 60 * 60
export const ONE_HOUR_IN_MS = ONE_HOUR_IN_SECONDS * 1000

export const MIN_DATE = '1900-01-01'
